import { checkAccessToken, checkRefreshToken } from '@/utils/tokenUtils'
import { type ReactNode, useEffect } from 'react'
import { productDomain } from '@/types/api'
import { useNavigate } from '@tanstack/react-router'
import { MOCK_ORDER_PATH, MockOrderPage } from '@/components/mock/MockOrderPage'
import { isWeChatBrowser } from '@/utils/ua'
export default function Auth({ children }: { children: ReactNode }) {
  const { isAuthenticated } = useAuth()
  const navigate = useNavigate()
  const pathname = typeof window !== 'undefined' ? window.location.pathname : ''
  
  if (pathname === MOCK_ORDER_PATH) {
    return <MockOrderPage />
  }

  if (
    pathname.includes('/test') &&
    window.location.hostname.includes(productDomain)
  ) {
    return (
      <p className="text-[4rem] text-center">生产域名无法访问开发测试路径</p>
    )
  }
  useEffect(() => {
    if (!isAuthenticated) {
      // 避免在登录页面也触发重定向，造成无限循环
      if (!publicRoutes.some((item) => pathname.includes(item))) {
        //如果不是微信浏览器则跳转引导页面
        if (!isWeChatBrowser()) {
          navigate({
            to: '/guide',
            search: { redirect: pathname },
            replace: true,
          })
        }else{
          navigate({
            to: '/login',
            // login.tsx 通过 URLSearchParams 读取 redirect，因此这里放到 search
            search: { redirect: pathname },
            replace: true,
          })
        }
      }
    }
  }, [isAuthenticated])
  return children
}

const publicRoutes = ['/login', '/test/manual-login', '/test/token-login']
function useAuth() {
  const isAuthenticated = checkAccessToken() && checkRefreshToken()
  return {
    isAuthenticated:
      isAuthenticated || publicRoutes.includes(window.location.pathname),
  }
}
